import { dataActionTypes } from "src/action_types/data_action_types";

const defaultState = {
  loadState: "loading",
  data: []
};

/**
 * Reducer for population data
 */
export function populationPrevalenceReducer(state = defaultState, action) {
  switch (action.type) {
    case dataActionTypes.populatePopulationPrevalenceChartData:
      return {
        data: action.payload,
        loadState: "loaded"
      };
    case dataActionTypes.populationPrevalenceChartDataLoading:
      return { ...state, loadState: "loading" };

    case dataActionTypes.populationPrevalenceChartDataLoadError:
      return { ...state, loadState: "error" };

    default:
      return state;
  }
}
